<template>
  <a-config-provider :locale="locale" >
    <div id="app">
      <router-view></router-view>
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
export default {
  name: 'App',
  data () {
    return {
      locale: zhCN
    }
  },
  created () {

  }
}
</script>

<style lang="scss">
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
}

#app {
  height: 100%;
  display: flex;
}

.amap-icon img {
  width: 25px !important;
  height: 34px !important;
}

.amap-marker-label {
  border: 0;
  width: 400px;
  height: 200px;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 2px 2px 15px rgba(204, 204, 204, 0.5);

  .title {
    display: flex;
    justify-content: flex-start;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 40px;

    .info {
      color: #999999;
      display: inline-block;
      margin-left: 20px;
    }
  }

  .line {
    font-size: 14px;
    margin: 15px 0;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    img {
      width: 20px;
      margin-right: 20px;
      height: 20px;
    }
  }
}

.amap-marker-label::before {
  content: "";
  position: absolute;
  left: -30px;
  top: 40%;
  right: auto;
  height: 10px;
  width: 10px;
  border-left: 15px solid transparent;
  border-right: 15px solid #fff;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;

}


</style>



// WEBPACK FOOTER //
// src/district/App.vue